// Station configuration. Swap URLs via /app/frontend/.env
export const STATIONS = [
  {
    id: "fm151",
    name: "FM 151",
    tagline: "Old School Soul",
    kind: "audio",
    src: process.env.REACT_APP_STREAM_FM151,
    image:
      "https://images.unsplash.com/photo-1776344651443-dc20c9f89c01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHx2aW55bCUyMHJlY29yZCUyMGdvbGQlMjBkYXJrfGVufDB8fHx8MTc4Njk4NjUyOHww&ixlib=rb-4.1.0&q=85",
    genre: "Soul • Motown • Classics",
  },
  {
    id: "vibe",
    name: "The Vibe",
    tagline: "Hip Hop & Today's R&B",
    kind: "audio",
    src: process.env.REACT_APP_STREAM_VIBE,
    image:
      "https://images.pexels.com/photos/19181684/pexels-photo-19181684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    genre: "Hip Hop • R&B • New School",
  },
  {
    id: "tv",
    name: "GFN Soul NYC TV",
    tagline: "Live Broadcast Network",
    kind: "video",
    src: process.env.REACT_APP_STREAM_TV,
    image:
      "https://images.unsplash.com/photo-1651465531201-7e430660fd82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHx0diUyMHN0dWRpbyUyMGNhbWVyYSUyMGJyb2FkY2FzdHxlbnwwfHx8fDE3ODY5ODY1Mjh8MA&ixlib=rb-4.1.0&q=85",
    genre: "Live Video • 24/7",
  },
];

export const HERO_BG = "/hero-banner.jpg";
